import 'moment/locale/th';
import React, { useState, useEffect } from 'react';
import { formatComma, tableWidth, getTheme } from 'helpers/helpers';
import callApi from 'helpers/callapi';
import moment from 'moment';
import _, { get, find, orderBy, uniqBy, filter } from 'lodash';
import { Link } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

// Components
import CONSTANTS from 'constants/constants';
import {
  Button,
  Table,
  Pagination,
  Modal,
  Row,
  Col,
  Select,
  message,
  Input,
  Upload,
  Radio,
  Spin,
  Checkbox,
  Tooltip,
  Tag,
} from 'antd';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { EditOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useLocation, useParams } from 'react-router';

import styled from 'styled-components';
import { filterLabelAndValue } from 'helpers/helpers';

// constants
import { TGATTPATINFOS, ALEVELINFOS } from 'constants/exam-days';
import { buildHistoryDayBySchool, DiffValue } from 'helpers/site-history';

// import AdminDetailModal from './AdminModal';

const ORDER_STATUS = CONSTANTS.orderStatus;
const ORDER_LABEL = CONSTANTS.orderLabels;
const BANK = CONSTANTS.banks;

const Option = Select.Option;

moment.locale('th');

// ปีที่แล้วที่ snapshot ไว้ใน examsitehistories (tasks/exams/snapshot-site-history.js ฝั่ง API)
const HISTORY_YEAR = '69';

// ห้อง/ที่นั่งรวมทุกประเภท (ปกติ + พิเศษ + CBT) ให้ตรงกับคอลัมน์ "ห้อง"/"ที่นั่งสอบ" ของตาราง
const totalStat = (stat) => ({
  rooms: (get(stat, 'rooms') || 0) + (get(stat, 'special_rooms') || 0) + (get(stat, 'cbt_rooms') || 0),
  seats: (get(stat, 'seats') || 0) + (get(stat, 'special_seats') || 0) + (get(stat, 'cbt_seats') || 0),
});

// จับคู่สนามข้ามปีด้วยรหัสโรงเรียน เพราะ site_code อาจเปลี่ยนเมื่อลบสนามแล้วเพิ่มใหม่
const siteKey = (site) => site.site_school_code || site.site_code;

// ผลต่าง = ปีนี้ − ปี 69 ใช้ป้ายลูกศรชุดเดียวกับหน้าอื่น (helpers/site-history)
const renderDiff = (current, previous) => <DiffValue current={current} previous={previous} />;

// ห้อง : ที่นั่ง ปี 69 ของสนาม — ถ้ารวมสนาม CBT เข้าไปด้วย บอกยอด CBT ที่รวมแล้วให้ชัด
const renderHistoryStat = (previous) => {
  if (!previous) return '-';
  return (
    <>
      {previous.rooms} : {formatComma(previous.seats)}
      {previous.hasCbt && !previous.cbtOnly && (
        <>
          <br />
          <small style={{ color: '#1a477f' }}>
            CBT {previous.cbtRooms} : {formatComma(previous.cbtSeats)}
          </small>
        </>
      )}
    </>
  );
};

export default () => {
  const EXAMDAYS = TGATTPATINFOS.concat(ALEVELINFOS);
  const { day } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const me = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('display'); // display, edit, sort
  const adminConfig = useSelector((state) => state.configs || {});

  const [selectedSites, setSelectedSites] = useState([]);
  const [sites, setSites] = useState([]);

  const [tempSelectedSites, setTempSelectedSite] = useState([]);
  const [historySites, setHistorySites] = useState([]);
  const [displayView, setDisplayView] = useState('site'); // site | province (เฉพาะโหมดแสดงผล)

  const dayInfo = find(EXAMDAYS, { dayIndex: parseInt(day, 10) });
  const [center, setCenter] = useState(null);

  const [isOpenDuplicateMenu, setIsOpenDuplicateMenu] = useState(false);

  const [duplicateDayValue, setDuplicateDayValue] = useState(day === '1' ? 2 : 1);

  let canEditTestDays;
  switch (adminConfig.center_active_test) {
    case 'TGATTPAT':
      canEditTestDays = ['1', '2', '3'];
      break;
    case 'ALEVEL':
      canEditTestDays = ['4', '5', '6'];
      break;
    default:
      canEditTestDays = [];
      break;
  }
  const canEdit = canEditTestDays.indexOf(day) > -1;
  console.log(adminConfig.center_active_test, canEdit, canEditTestDays);

  useEffect(() => {
    if (day === '6' || day === '7') {
      setDuplicateDayValue(5);
    } else if (day === '5') {
      setDuplicateDayValue(6);
    }
  }, [day]);

  const onCheckAll = () => {
    if (sites.length === tempSelectedSites.length) {
      setTempSelectedSite([]);
    } else {
      setTempSelectedSite(sites.map((site) => site.site_code));
    }
  };

  const onCheckSite = (siteCode) => {
    if (tempSelectedSites.indexOf(siteCode) === -1) {
      setTempSelectedSite([...tempSelectedSites, siteCode]);
      return;
    }
    let newSelectedSite = _.filter(tempSelectedSites, (_site_code) => _site_code !== siteCode);
    setTempSelectedSite(newSelectedSite);
  };

  const getSites = async () => {
    const _sites = await callApi({ url: '/exam-centers/me/sites' });
    setSites(_sites.data);
  };

  const getSelectedSites = async () => {
    const _sites = await callApi({ url: `/exam-centers/me/days/${day}/sites` });
    setSelectedSites(_sites);
  };

  const onClickEditButton = () => {
    const _tempSelectedSites = selectedSites.map((site) => site.site_code);
    setMode('edit');
    setTempSelectedSite(_tempSelectedSites);
  };
  const onCancelEdit = () => {
    setMode('display');
    const _tempSelectedRooms = selectedSites.map((site) => site.site_code);
    setTempSelectedSite(_tempSelectedRooms);
  };

  const onClickUpdateSiteButton = async () => {
    setLoading(true);
    // const ids = rooms.map((room) => room._id);
    try {
      await callApi({
        url: `/exam-centers/${me.center_code}/days/${day}/sites`,
        method: 'post',
        body: { sites: tempSelectedSites },
      });
      await getSelectedSites();
      await getCenter();
      setLoading(false);
      setMode('display');
    } catch (err) {
      message.error(get(err, 'reason[0].message'));
      setLoading(false);
    }
  };
  const getCenter = async () => {
    const center = await callApi({ url: '/exam-centers/me' });
    setCenter(center);
  };
  const getHistory = async () => {
    try {
      const result = await callApi({ url: `/exam-centers/me/history/${HISTORY_YEAR}/sites` });
      setHistorySites(result.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // สถิติปี 69 ของวันสอบหมายเลขเดียวกัน รวมตามรหัสโรงเรียน
  // - สนาม PBT + สนาม CBT ของโรงเรียน/มหาวิทยาลัยเดียวกัน (รหัสโรงเรียนซ้ำกัน) ถูกรวมเป็นรายการเดียว
  //   เพราะปีนี้ไม่มี CBT แล้ว ต้องเอาที่นั่ง CBT มารวมกับปกติ
  // - สนาม CBT ที่ไม่เหลือข้อมูลห้องรายวันเลย ใช้ห้องต้นแบบ (stats) แทน และติดป้าย "ห้องต้นแบบ"
  const historyDayBySchool = buildHistoryDayBySchool(historySites, day);

  // สนามปี 69 ทั้งหมดที่นับสำหรับวันนี้
  const historyDayRows = _.values(historyDayBySchool);
  const historyDayTotal = historyDayRows.reduce(
    (acc, stat) => ({ sites: acc.sites + 1, rooms: acc.rooms + stat.rooms, seats: acc.seats + stat.seats }),
    { sites: 0, rooms: 0, seats: 0 },
  );
  const currentSchoolKeys = _.keyBy(sites, siteKey);
  const selectedSchoolKeys = _.keyBy(selectedSites, siteKey);

  // สนามที่ปี 69 ใช้ในวันนี้ แต่ปีนี้ยังไม่ได้เลือก — แยกว่ายังอยู่ในรายการสนามของศูนย์ (เพิ่มได้) หรือหายไปแล้ว
  const missingSites = _.sortBy(
    historyDayRows
      .filter((stat) => !selectedSchoolKeys[siteKey(stat.site)])
      .map((stat) => ({
        ...stat,
        currentSite: currentSchoolKeys[siteKey(stat.site)],
      })),
    (row) => (row.currentSite ? 0 : 1),
    (row) => -row.seats,
  );

  // รายจังหวัด: ปีนี้จากสนามที่เลือกวันนี้ / ปี 69 จาก historyDayRows
  const provinceRows = (() => {
    const byProvince = {};
    const ensure = (province) => {
      if (!byProvince[province]) {
        byProvince[province] = {
          province,
          current: { sites: 0, rooms: 0, seats: 0 },
          previous: { sites: 0, rooms: 0, seats: 0 },
        };
      }
      return byProvince[province];
    };
    selectedSites.forEach((site) => {
      const stat = totalStat(get(site, `info_by_days.day${day}`));
      const row = ensure(site.province);
      row.current.sites += 1;
      row.current.rooms += stat.rooms;
      row.current.seats += stat.seats;
    });
    historyDayRows.forEach((stat) => {
      const row = ensure(stat.site.province);
      row.previous.sites += 1;
      row.previous.rooms += stat.rooms;
      row.previous.seats += stat.seats;
    });
    return _.sortBy(_.values(byProvince), (row) => -Math.max(row.current.seats, row.previous.seats));
  })();

  // จากแถว "ปี 69 ใช้แต่ปีนี้ยังไม่เลือก" → เข้าโหมดแก้ไขโดยติ๊กสนามนั้นเพิ่มให้ทันที
  const onAddFromHistory = (siteCode) => {
    setMode('edit');
    setTempSelectedSite(_.uniq([...selectedSites.map((site) => site.site_code), siteCode]));
  };

  // เลือกสนามตามที่ใช้ปี 69 (โหมดแก้ไข)
  const onSelectLikeHistory = () => {
    setTempSelectedSite(sites.filter((site) => historyDayBySchool[siteKey(site)]).map((site) => site.site_code));
  };

  const onSubmitDuplicateData = async () => {
    setLoading(true);
    // const ids = rooms.map((room) => room._id);
    await callApi({
      url: `/exam-centers/${me.center_code}/days/${day}/duplicate/${duplicateDayValue}`,
      method: 'post',
    });
    await getSelectedSites();
    await getCenter();
    setLoading(false);
    setMode('display');
  };

  useEffect(() => {
    getSites();
    getSelectedSites();
    getCenter();
    getHistory();
  }, []);

  const renderTable = () => {
    return (
      <>
        <thead className="th-orange">
          <tr>
            <th>ลำดับ</th>
            <th>ชื่อสนามสอบ</th>
            <th>รหัส</th>
            <th>จังหวัด</th>
            <th>อำเภอ</th>
            <th className="text-right t-group-start">ห้อง</th>
            <th className="text-right">ที่นั่งสอบ</th>
            <th className="text-right t-group-start">
              <Tooltip title="ห้องสอบปกติ กระดาษ">
                <i className="i-paper"></i>
              </Tooltip>
            </th>
            <th className="text-center">
              <Tooltip title="ห้องสอบสำหรับผู้ต้องการความช่วยเหลือพิเศษ กระดาษ">
                <i className="i-disabled"></i>
              </Tooltip>
            </th>
            <th className="text-center">
              <Tooltip title="ห้องสอบปกติ คอมพิวเตอร์">
                <i className="i-computer"></i>
              </Tooltip>
            </th>
            <th className="text-center _nowrap t-group-start">
              <Tooltip title={`ห้อง : ที่นั่ง ที่สนามนี้เปิดสอบในปี ${HISTORY_YEAR}`}>
                <span>ปี {HISTORY_YEAR}</span>
              </Tooltip>
            </th>
            <th className="text-right _nowrap">
              <Tooltip title={`ที่นั่งปีนี้ - ที่นั่งปี ${HISTORY_YEAR}`}>
                <span>ผลต่าง</span>
              </Tooltip>
            </th>

            <th></th>
          </tr>
        </thead>
        <tbody>
          {selectedSites.map((site, i) => {
            const stat = get(site, `info_by_days[day${day}]`);
            const previous = historyDayBySchool[siteKey(site)];
            const currentSeats = get(stat, 'seats') + (get(stat, 'special_seats') || 0) + (get(stat, 'cbt_seats') || 0);
            return (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{site.school_name}</td>
                <td>{site.site_school_code}</td>
                <td>{site.province}</td>
                <td>{site.amphur}</td>
                <td className="_nowrap text-right t-group-start">
                  {get(stat, 'rooms') + (get(stat, 'special_rooms') || 0) + (get(stat, 'cbt_rooms') || 0)}
                </td>
                <td className="_nowrap text-right">
                  {get(stat, 'seats') + (get(stat, 'special_seats') || 0) + (get(stat, 'cbt_seats') || 0)}
                </td>
                <td className="_nowrap text-center t-group-start">
                  {get(stat, 'rooms')} : {get(stat, 'seats')}
                </td>
                <td className="_nowrap text-center">
                  {get(stat, 'special_rooms')} : {get(stat, 'special_seats')}
                </td>
                <td className="_nowrap text-center">
                  {get(stat, 'cbt_rooms')} : {get(stat, 'cbt_seats')}
                </td>
                <td className="_nowrap text-center t-group-start" style={{ color: '#828897' }}>
                  {renderHistoryStat(previous)}
                </td>
                <td className="_nowrap text-right">{renderDiff(currentSeats, previous ? previous.seats : 0)}</td>
                <td>
                  <Link to={`/day/${dayInfo.dayIndex}/site/${site.site_code}/room`} className="btn-manage">
                    {canEdit ? 'จัดการห้องสอบ' : 'ดูข้อมูลห้องสอบ'}
                  </Link>
                </td>
              </tr>
            );
          })}
          {missingSites.length > 0 && (
            <tr style={{ background: '#fff1f0' }}>
              <td colSpan="13" style={{ color: '#e02020', fontWeight: 'bold' }}>
                ปี {HISTORY_YEAR} ใช้สนามสอบเหล่านี้ แต่ปีนี้ยังไม่ได้เลือก ({missingSites.length} สนาม /{' '}
                {formatComma(_.sumBy(missingSites, 'seats'))} ที่นั่ง)
              </td>
            </tr>
          )}
          {missingSites.map((row) => (
            <tr key={`missing-${siteKey(row.site)}`} style={{ color: '#979797', background: '#fafafa' }}>
              <td></td>
              <td>
                {row.site.school_name}{' '}
                {row.hasCbt && row.cbtOnly && <Tag color="blue">CBT</Tag>}
                {!row.currentSite && <Tag color="red">ไม่มีในรายการปีนี้</Tag>}
                {row.fromStats && (
                  <Tooltip title={`ปี ${HISTORY_YEAR} ไม่มีข้อมูลห้องรายวันของสนามนี้ ตัวเลขที่แสดงคือห้องต้นแบบของสนาม`}>
                    <Tag>ห้องต้นแบบ</Tag>
                  </Tooltip>
                )}
              </td>
              <td>{row.site.site_school_code}</td>
              <td>{row.site.province}</td>
              <td>{row.site.amphur}</td>
              <td className="_nowrap text-right t-group-start">-</td>
              <td className="_nowrap text-right">-</td>
              <td className="_nowrap text-center t-group-start">-</td>
              <td className="_nowrap text-center">-</td>
              <td className="_nowrap text-center">-</td>
              <td className="_nowrap text-center t-group-start">{renderHistoryStat(row)}</td>
              <td className="_nowrap text-right">{renderDiff(0, row.seats)}</td>
              <td>
                {row.currentSite && canEdit && (
                  <a className="btn-manage" onClick={() => onAddFromHistory(row.currentSite.site_code)}>
                    เพิ่มสนามสอบ
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </>
    );
  };

  const renderEditTable = () => {
    let runningNumber = 0;
    return (
      <>
        <thead className="th-orange">
          <tr>
            <th>
              <Checkbox checked={tempSelectedSites.length === sites.length} onChange={() => onCheckAll()}></Checkbox>
            </th>
            <th>ลำดับ</th>
            <th>ชื่อสนามสอบ</th>
            <th>รหัส</th>
            <th>จังหวัด</th>
            <th>อำเภอ</th>
            <th>ห้อง</th>
            <th>
              <i className="i-paper"></i>
            </th>
            <th>
              <i className="i-disabled"></i>
            </th>
            <th>
              <i className="i-computer"></i>
            </th>
            <th>ที่นั่งสอบ</th>
            <th className="_nowrap" style={{ borderLeft: '2px solid #fff' }}>
              <Tooltip title={`ห้อง : ที่นั่ง ที่สนามนี้เปิดสอบในปี ${HISTORY_YEAR}`}>
                <span>ปี {HISTORY_YEAR}</span>
              </Tooltip>
            </th>
          </tr>
        </thead>
        <tbody>
          {sites.map((site, i) => {
            const previous = historyDayBySchool[siteKey(site)];
            let stat = get(site, `info_by_days[day${day}]`);
            console.log(get(stat, 'rooms'), get(stat, 'special_rooms'), get(stat, 'cbt_rooms'));
            if (!(get(stat, 'rooms') || get(stat, 'special_rooms') || get(stat, 'cbt_rooms'))) {
              stat = get(site, `stats`);
            }

            const isChecked = tempSelectedSites.indexOf(site.site_code) > -1;
            if (isChecked) {
              runningNumber++;
            }
            return (
              <tr key={i}>
                <td>
                  <Checkbox checked={isChecked} onChange={() => onCheckSite(site.site_code)}></Checkbox>
                </td>
                <td>{isChecked && runningNumber} </td>
                <td>{site.school_name}</td>
                <td>{site.site_school_code}</td>
                <td>{site.province}</td>
                <td>{site.amphur}</td>

                <td className="_nowrap">
                  {(get(stat, 'rooms') || 0) + (get(stat, 'special_rooms') || 0) + (get(stat, 'cbt_rooms') || 0)}
                </td>
                <td className="_nowrap">
                  {(get(stat, 'seats') || 0) + (get(stat, 'special_seats') || 0) + (get(stat, 'cbt_seats') || 0)}
                </td>

                <td className="_nowrap">
                  {get(stat, 'rooms')} : {get(stat, 'seats')}
                </td>
                <td className="_nowrap">
                  {get(stat, 'special_rooms')} : {get(stat, 'special_seats')}
                </td>
                <td className="_nowrap">
                  {get(stat, 'cbt_rooms')} : {get(stat, 'cbt_seats')}
                </td>
                <td className="_nowrap" style={{ color: previous ? '#0b9c23' : '#979797' }}>
                  {renderHistoryStat(previous)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </>
    );
  };

  const renderProvinceTable = () => (
    <>
      <thead className="th-orange">
        <tr>
          <th rowSpan="2">จังหวัด</th>
          <th colSpan="3" className="text-center t-group-start">
            สนามสอบ
          </th>
          <th colSpan="3" className="text-center t-group-start">
            ห้อง
          </th>
          <th colSpan="3" className="text-center t-group-start">
            ที่นั่งสอบ
          </th>
        </tr>
        <tr>
          <th className="text-right t-group-start">ปี {HISTORY_YEAR}</th>
          <th className="text-right">ปีนี้</th>
          <th className="text-right">ผลต่าง</th>
          <th className="text-right t-group-start">ปี {HISTORY_YEAR}</th>
          <th className="text-right">ปีนี้</th>
          <th className="text-right">ผลต่าง</th>
          <th className="text-right t-group-start">ปี {HISTORY_YEAR}</th>
          <th className="text-right">ปีนี้</th>
          <th className="text-right">ผลต่าง</th>
        </tr>
      </thead>
      <tbody>
        {provinceRows.map((row) => (
          <tr key={row.province}>
            <td>{row.province}</td>
            <td className="text-right t-group-start">{row.previous.sites || '-'}</td>
            <td className="text-right">
              <b>{row.current.sites || '-'}</b>
            </td>
            <td className="text-right">{renderDiff(row.current.sites, row.previous.sites)}</td>
            <td className="_nowrap text-right t-group-start">{row.previous.rooms ? formatComma(row.previous.rooms) : '-'}</td>
            <td className="_nowrap text-right">
              <b>{row.current.rooms ? formatComma(row.current.rooms) : '-'}</b>
            </td>
            <td className="_nowrap text-right">{renderDiff(row.current.rooms, row.previous.rooms)}</td>
            <td className="_nowrap text-right t-group-start">{row.previous.seats ? formatComma(row.previous.seats) : '-'}</td>
            <td className="_nowrap text-right">
              <b>{row.current.seats ? formatComma(row.current.seats) : '-'}</b>
            </td>
            <td className="_nowrap text-right">{renderDiff(row.current.seats, row.previous.seats)}</td>
          </tr>
        ))}
        <tr style={{ fontWeight: 'bold', background: '#fff6e5' }}>
          <td>รวมทั้งศูนย์สอบ</td>
          <td className="text-right t-group-start">{historyDayTotal.sites}</td>
          <td className="text-right">{selectedSites.length}</td>
          <td className="text-right">{renderDiff(selectedSites.length, historyDayTotal.sites)}</td>
          <td className="_nowrap text-right t-group-start">{formatComma(historyDayTotal.rooms)}</td>
          <td className="_nowrap text-right">{formatComma(currentDayTotal.rooms)}</td>
          <td className="_nowrap text-right">{renderDiff(currentDayTotal.rooms, historyDayTotal.rooms)}</td>
          <td className="_nowrap text-right t-group-start">{formatComma(historyDayTotal.seats)}</td>
          <td className="_nowrap text-right">{formatComma(currentDayTotal.seats)}</td>
          <td className="_nowrap text-right">{renderDiff(currentDayTotal.seats, historyDayTotal.seats)}</td>
        </tr>
      </tbody>
    </>
  );

  const dayStat = get(center, `info_by_days.day${day}`);
  // ยอดปีนี้ของวันนี้ นับจากสนามที่เลือก (ชุดเดียวกับตาราง) ให้สอดคล้องกับผลต่างรายสนาม/รายจังหวัด
  const currentDayTotal = selectedSites.reduce(
    (acc, site) => {
      const stat = totalStat(get(site, `info_by_days.day${day}`));
      return { sites: acc.sites + 1, rooms: acc.rooms + stat.rooms, seats: acc.seats + stat.seats };
    },
    { sites: 0, rooms: 0, seats: 0 },
  );

  const duplicateOptions = ['1', '2', '3', '4'].indexOf(day) > -1 ? TGATTPATINFOS : ALEVELINFOS;

  return (
    <div>
      <Spin spinning={loading} delay={0}>
        <div className="t-main">
          <h1>จัดการสนามสอบ</h1>
          <div className="round">
            <div className="round-date">
              <span className="number">{dayInfo.index}</span> <span className="date">{dayInfo.date}</span>
            </div>
            <div className="round-time">
              {dayInfo.examSlots.map((slot) => {
                return (
                  <div className="item">
                    {slot.time} <span className="color-blue">{slot.subject}</span>
                  </div>
                );
              })}
            </div>
            <div className="round-body">
              <div className="col text-center">
                <span>จำนวนสนามสอบ</span> <br />
                {me.exam_type === 'cbt' && <b>{get(dayStat, `cbt_sites`) || 0}</b>}
                {me.exam_type === 'pbt' && <b>{get(dayStat, `pbt_sites`) || 0}</b>}
                {me.exam_type === 'cbt_pbt' && <b>{get(dayStat, `cbt_sites`) + get(dayStat, `pbt_sites`) || 0}</b>}
              </div>
              <div className="col text-center">
                <span>จำนวนห้องสอบ</span> <br />
                {me.exam_type === 'cbt' && <b>{get(dayStat, `cbt_rooms`) || 0}</b>}
                {me.exam_type === 'pbt' && <b>{get(dayStat, `rooms`) + get(dayStat, `special_rooms`)}</b>}
                {me.exam_type === 'cbt_pbt' && (
                  <b>{get(dayStat, `cbt_rooms`) + get(dayStat, `rooms`) + get(dayStat, `special_rooms`) || 0}</b>
                )}
              </div>
              <div className="col text-center">
                <span>จำนวนที่นั่ง</span> <br />
                {me.exam_type === 'cbt' && <b>{get(dayStat, `cbt_seats`) || 0}</b>}
                {me.exam_type === 'pbt' && <b>{get(dayStat, `seats`) + get(dayStat, `special_seats`)}</b>}
                {me.exam_type === 'cbt_pbt' && (
                  <b>{get(dayStat, `cbt_seats`) + get(dayStat, `seats`) + get(dayStat, `special_seats`) || 0}</b>
                )}
              </div>
            </div>
            {/* แถวเทียบปี 69 วางไว้คอลัมน์เดียวกับตัวเลขปีนี้ (คอลัมน์ที่ 3 ของ .round) ให้ตัวเลขตรงระนาบกัน */}
            {historySites.length > 0 && (
              <div style={{ gridColumn: '1 / 3', background: 'var(--s-bg-2)', borderTop: '1px dashed #d5d5d7' }}></div>
            )}
            {historySites.length > 0 && (
              <div
                className="round-body"
                style={{
                  gridColumn: '3',
                  borderTop: '1px dashed #d5d5d7',
                  color: '#828897',
                }}
              >
                <div className="col text-center">
                  <span>สนามสอบปี {HISTORY_YEAR}</span> <br />
                  <b>{historyDayTotal.sites}</b> สนาม {renderDiff(currentDayTotal.sites, historyDayTotal.sites)}
                </div>
                <div className="col text-center">
                  <span>ห้องสอบปี {HISTORY_YEAR}</span> <br />
                  <b>{formatComma(historyDayTotal.rooms)}</b> {renderDiff(currentDayTotal.rooms, historyDayTotal.rooms)}
                </div>
                <div className="col text-center">
                  <span>ที่นั่งปี {HISTORY_YEAR}</span> <br />
                  <b>{formatComma(historyDayTotal.seats)}</b> {renderDiff(currentDayTotal.seats, historyDayTotal.seats)}
                </div>
              </div>
            )}
          </div>
          <div className="_space"></div>
          <div className="flex justify-between">
            <h2>
              <i className="i-school-orange"></i> เลือก {selectedSites.length} จาก {sites.length} แห่ง
            </h2>

            {canEdit && (
              <a
                class="venue-duplicate-toggle color-green"
                onClick={() => setIsOpenDuplicateMenu(!isOpenDuplicateMenu)}
              >
                ต้องการคัดลอกข้อมูลจากวันสอบอื่น ?
              </a>
            )}
          </div>
          {isOpenDuplicateMenu && (
            <div class="venue-duplicate-collapse active">
              <div class="t-card border-orange">
                <h3>คัดลอกข้อมูลจากวันสอบอื่น</h3>
                <div class="flex">
                  <div class="col-1 min-w-20">
                    <div class="form-group">
                      <label>เลือกวันสอบ</label>
                      <Select
                        value={duplicateDayValue}
                        onChange={async (value) => {
                          setDuplicateDayValue(value);
                        }}
                        size={'large'}
                        style={{ width: '100%' }}
                      >
                        {duplicateOptions.map((INFO) => {
                          if (INFO.dayIndex.toString() === day) {
                            return <></>;
                          }
                          return <Select.Option value={INFO.dayIndex}>{INFO.date}</Select.Option>;
                        })}
                      </Select>
                    </div>
                  </div>
                  <div class="col-action col-3">
                    <small>
                      <b>คำเตือน</b> เมื่อคลิก “ยืนยัน” ระบบจะลบข้อมูล
                      <br />
                      ที่เลือกไว้ก่อนหน้าทั้งหมด แล้วทำการคัดลอกข้อมูล
                    </small>
                  </div>
                  <div class="col-action col-1">
                    <a class="btn-main" onClick={() => onSubmitDuplicateData()}>
                      <i class="i-add"></i> ยืนยัน
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}

          {mode === 'display' && historySites.length > 0 && (
            <div className="flex justify-between" style={{ marginBottom: 12 }}>
              <div></div>
              <Radio.Group onChange={(e) => setDisplayView(e.target.value)} value={displayView} buttonStyle="solid">
                <Radio.Button value="site">สนามสอบ</Radio.Button>
                <Radio.Button value="province">รายจังหวัด เทียบปี {HISTORY_YEAR}</Radio.Button>
              </Radio.Group>
            </div>
          )}
          <table className="t-table t-table-striped">
            {mode === 'display' && displayView === 'site' && renderTable()}
            {mode === 'display' && displayView === 'province' && renderProvinceTable()}
            {mode === 'edit' && renderEditTable()}
          </table>

          <div className="_space"></div>

          {mode === 'display' && canEdit && (
            <a className="btn-ghost pointer" onClick={() => onClickEditButton()}>
              เพิ่ม-ลด สนามสอบ
            </a>
          )}
          {mode === 'edit' && (
            <>
              {historyDayTotal.sites > 0 && (
                <a className="btn-ghost pointer" style={{ marginRight: 12 }} onClick={() => onSelectLikeHistory()}>
                  เลือกตามปี {HISTORY_YEAR}
                </a>
              )}
              <a className="btn-main btn-radius" onClick={() => onClickUpdateSiteButton()}>
                บันทึกข้อมูล
              </a>
              <a className="_h" onClick={() => onCancelEdit(null)}>
                ยกเลิก
              </a>
            </>
          )}
        </div>
      </Spin>
    </div>
  );
};
